export default "__VITE_ASSET__b0owIU9F__"